module.exports = __webpack_public_path__ + "img/explorer_logo_black.82fd714e.png";